import React from "react";
import "./ResearchGroup.css";

const ResearchGroup = () => {
  return (
    <div className="research-container">
      <section className="mission-section">
        <h1 id="researchGroupHeader">Group Mission</h1>

        <p className="lead-text">
          Our group is composed of graduate students, postdoctoral researchers and engineers. We collaborate to improve coherence times 
          by applying a variety of advanced materials characterization tools — electron microscopy, X-ray photoelectron spectroscopy and 
          time-of-flight secondary ion mass spectrometry — to understand the physical processes that lead to the loss of quantum information, 
          called decoherence. Using these techniques as part of a materials-oriented approach, the SQMS research team has recently achieved 
          leading coherence times in transmon qubits. We aim to answer questions such as:
        </p>

        <ul className="mission-list">
          <li>Are the surfaces of these materials ordered or disordered? What about the interfaces between materials?</li>
          <li>What impurities are present in our materials? Where are they located?</li>
          <li>What types of defects are present in these devices? How do they respond during device operation at cryogenic temperatures?</li>
        </ul>
      </section>

      <section className="role-section">
        <p>
          As part of the Superconducting Materials and Systems (SQMS) center, a U.S. DOE National Quantum Information Science Research Center, 
          I serve as the deputy center director and the leader for the materials focus area, which includes groups focused on nanofabrication, 
          structural/chemical characterization, superconducting characterization, and microwave measurements. As part of this role, I have led 
          a comprehensive and coordinated blind study with qubit chips of known performance variations probed across multiple institutions, 
          including Ames Lab, Northwestern, and Fermilab, in an effort that brings together over 40 researchers in the materials science and 
          superconducting materials domains. These qubits have been interrogated with various unique non-destructive and destructive characterization 
          techniques to pinpoint the underlying materials-level sources of device-to-device performance variation giving rise to decoherence
        </p>
        <p>
          I am extremely passionate about advancing the performance of superconducting qubit platforms, 
          with my ultimate goal being to help deliver a transformational new paradigm in computing.
        </p>
      </section>

      <div className="contact-cta">
        <h5>Please contact me if you are interested in joining our team!</h5>
      </div>
    </div>
  );
};

export default ResearchGroup;